<template>
  <div class="d-flex align-center flex-column">
    <v-icon :color="iconColor" :size="48">{{ mdiStar }}</v-icon>
    <div>{{ highlightsCount }}</div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mdiStar } from "@mdi/js"
import { useVuetify, useVuetifyTheme } from "features/common/vuetify/useVuetify"

export default defineComponent({
  name: "EventHighlightsIcon",
  props: {
    highlightsCount: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const iconColor = useVuetify().theme.themes.light.textColor

    return {
      mdiStar,
      iconColor,
    }
  },
})
</script>
